<template>
    <RedesignFormItem :label="$t('layout.config.WidgetTableHeaderFontSize')">
        <RedesignInputNumber
            v-model="model"
            :max-value="optionConfigs.WidgetTableHeaderFontSize.max"
            :min-value="optionConfigs.WidgetTableHeaderFontSize.min"
            :step="optionConfigs.WidgetTableHeaderFontSize.step"
            size="small"
            placeholder="0"
        />
    </RedesignFormItem>
</template>

<script setup lang="ts">
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import { computed } from 'vue'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import { widgetTableHeaderFontSize } from '@/composables/globalData/useLayouts'

const props = defineProps<{
    value?: string
}>()

const emit = defineEmits([ 'input' ])

const model = computed({
    get () {
        return stringValueToNumber(stringValue.value)
    },
    set (val) {
        emit('input', numberValueToString(val))
    }
})


const hasOwnValue = computed(() => {
    return props.value !== undefined
})

const layoutConfig = computed(() => {
    return widgetTableHeaderFontSize.value
})

const stringValue = computed(() => {
    if (hasOwnValue.value) {
        return props.value || ''
    } else {
        return layoutConfig.value?.fontSize
    }
})

/* Methods */
function stringValueToNumber (value: string) {
    return parseInt(value.replace('px', ''))
}
function numberValueToString (value: number) {
    return `${value}px`
}
</script>

